<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="col-md-8 text-left" id="challenge-content-text">
                        <div class="title">
                            <h4><span><img v-if="challengeObj.Icon !== 'no'" alt="challenge icon" class="challenge-icon" :src="challengeObj.Icon"/>{{challengeObj['.key']}}</span></h4>
                        </div><br><br>

                        <div class="problem-text">
                            <div class="problem-title">
                                <h5>Problem</h5>
                            </div>
                            {{challengeObj.Problem}}
                        </div><br><br>

                        <div class="instruction-text">
                            <div class="instruction-title">
                                <h5 >Instructions</h5>
                            </div>
                            <div class="every-instruction" v-for="(instruction, index) of challengeObj.Instructions" :key="index">
        
                                <span><font-awesome-icon class="fa" icon="check-circle" />
                                    {{instruction}}</span>
                            </div>
                        </div><br><br>

                        <div class="submission-text">
                            <div class="submission-title">
                                <h5>Submission and Deadlines</h5>
                            </div>
                            {{challengeObj.Submission}}
            
                            Submissions go through a review cycle, and then voting begins. The top 3 submissions will be announced on the website and the newsletter. <br><br>
						Submission deadline: <b>{{getDate(deadlineSubmission)}}</b><br>
                        
						Voting deadline: <b>{{getDate(deadlineVoting)}}</b><br><br>

						Winners will be announced shortly after the voting ends.
                        </div>
                        
                        
                    </div>
                    <div v-if="isRegistered === true" class="col-md-4">
                        <RegisterCard 
                            v-bind:title="challengeObj['.key']"
                            v-bind:rewardText="challengeObj.Reward"
                            v-bind:slug = "challengeObj.Slug"
                            v-bind:clickCard="clickCard"
                            ctaText="SUBMIT WORK"
                            ctaUrl="/submit-work">
                        </RegisterCard>
                    </div>

                    <div v-else class="col-md-4">
                        <RegisterCard 
                            v-bind:title="challengeObj['.key']"
                            v-bind:rewardText="challengeObj.Reward"
                            v-bind:slug = "challengeObj.Slug"
                            v-bind:clickCard="clickCard"
                            calledFrom="Challenge"
                            ctaText="REGISTER NOW"
                            ctaUrl="/submit-work">
                        </RegisterCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import RegisterCard from '@/components/RegisterCard.vue'
import firebase from '../services/firebase'


export default {
    name: 'Challenge',
    components: {
        NavBarLight,
        RegisterCard
    },
    data: function() {
        return {
            challenges: [],
            deadlineSubmission: null,
            deadlineVoting: null,
            registeredUsers: [],
            challengeKey: ''
        }
    },
    firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true)
    },
    computed: {
        challengeObj: function() {
            for (var key in this.challenges) {
                console.log("slug is " + this.challenges[key].Slug);
                if (this.challenges[key].Slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.challenges[key].Slug);
                    this.challengeKey = this.challenges[key]['.key'];
                    this.deadlineSubmission = this.challenges[key].Deadline;
                    this.deadlineVoting = this.challenges[key].Voting;
                    this.registeredUsers = this.challenges[key].Registered_users;
                    return this.challenges[key];
                }
            }
        },
        isRegistered: function() {
            for (var i in this.registeredUsers) {
                //console.log("inside isRegistered i is " + this.registeredUsers[i]);
                //console.log("uid is " + firebase.auth().currentUser.uid);
                if (this.registeredUsers[i] === firebase.auth().currentUser.uid) {
                    console.log("user with uid " + this.registeredUsers[i] + " is registered");
                    return true;
                }
            }
            return false;
        }
        
    },
    created: function() {
        mixpanel.track("entered challenge", 
        {
            "challenge_name": this.$route.params.slug,
            "user_id": firebase.auth().currentUser.uid,
            "email": firebase.auth().currentUser.email
        });
    },
    methods: {
        clickCard: function(slug_sent) {
           // alert("register clicked, in challenge vue, slug sent is " + slug_sent);
            mixpanel.track("challenge clicked register", 
            {
                "company_challenge": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            if (this.isRegistered) {
                this.$router.push(this.$route.path + '/submit-work');
            }

            else {
                var length = 0;
                for(var i in this.registeredUsers) {
                    console.log("user registered for the challenge is " + this.registeredUsers[i]);
                    length ++;
                }
                var uid = firebase.auth().currentUser.uid;
                console.log("uid in clickcard is " + uid);
                this.registeredUsers[length] = uid;
                
                firebase.database().ref('challenges/UX/' + this.challengeKey).update({Registered_users: this.registeredUsers});
                
            }
        },
        getDate: function(ts) {
            return new Date(ts*1000);
        }
    }
}
</script>


<style scoped>

    .content-start {
        margin-top:50px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:3.5%;
        margin-right:4%;
        padding-right:0%;
    }

    #challenge-content-text {
        padding-right:7%;
    }

    .challenge-icon {
        margin-left:-10px;
        margin-right:20px; 
        width:100px;
        height:50px;
    }

    .problem-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .instruction-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .submission-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .every-instruction {
        margin-bottom:3px;
    }

    .problem-text {
        font-size: 0.9rem;
    }

    .instruction-text {
        font-size: 0.9rem;
    }

    .submission-text {
        font-size: 0.9rem;
    }

    .fa {
        margin-right:10px; 
        color:green
    }

</style>
